export default {
  show_post: 'Sprawdź',
  show_posts: 'Pokaż wszystkie',
  load_more: 'Doładuj więcej',
  back: 'Wstecz',
  language_pl: 'Polski',
  language_en: 'Angielski',
  language_no: 'Norweski',
  change_language: 'Zmień język',
  company_about: 'O kliencie',
  case_study: 'Case study',
  share_this: 'Share this:',
  caseStudy_button: 'Zobacz',
  article_readTime: "You'll read this article in",
  article_minutes: 'minutes',
  header_menu: 'MENU',
  header_menu_closed: 'CLOSE MENU',
  cookieButton: 'Ok, zgadzam się!',
  cookiesDisabled: 'Zaakceptuj cookie, by strona działała poprawnie',
  articles: 'Artykuły',
  all_categories: 'na każdy temat',
  categories: 'Kategorie',
  cookieNoConsent:
    '<h4>Strona korzysta z ciasteczek</h4><p>Wyrażam zgodę na przetwarzanie moich danych osobowych zbieranych w plikach cookies. Pliki cookies umożliwiają analizowanie i profilowanie w celach marketingowych. Na podstawie zebranych informacji Spółka może wyświetlać mi reklamy. Wyrażenie powyższej zgody jest dobrowolne. Wycofanie zgody jest możliwe w dowolnym momencie za pośrednictwem maila: <a href="mailto:data@testarmy.com">data@testarmy.com</a> albo poprzez samodzielne wyłączenie plików cookies w ustawieniach przeglądarki. Wycofanie zgody nie będzie miało wpływu na zgodność z prawem przetwarzania na podstawie zgody, przed jej wycofaniem.</p>',
  search: 'Szukaj',
  recommended: 'Polecane',
  publication_date: 'Data publikacji: ',
  learn_more: 'Zobacz więcej',
  our_missions: 'Nasze przykładowe misje',
  no_results: 'Brak wyników.',
  next_slide: 'Następna strona',
  prev_slide: 'Poprzednia strona',
  slide_message: 'Idź do strony {{index}}',
  ebooks: 'Ebooki',
  webinars: 'Webinary',
  language: 'wybierz język',
  show_more_case_studies: 'Zobacz więcej case studies',
  table_of_contents: 'Spis treści',
};
